const generateNumber = (setState, state) => {
  const max = 10000000000000000;
  let rand = Math.random() * Math.floor(max);
  rand = String(rand).slice(0, 12);
  setState({
    ...state,
    random_number: rand,
  });
};

export default generateNumber;
